import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PaymentMethod {
  id: string;
  method_type: 'cash' | 'paypal' | 'stripe';
  is_active: boolean;
  is_sandbox: boolean;
  settings: any;
}

export const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const fetchPaymentMethods = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase.rpc('get_public_payment_methods');

      if (error) throw error;
      setPaymentMethods(((data || []) as any[]).map(d => ({ ...d, settings: {} })) as PaymentMethod[]);
      setError(null);
    } catch (err) {
      console.error('Error fetching payment methods:', err);
      setError('Error loading payment methods');
    } finally {
      setLoading(false);
    }
  };

  const getMethodTitle = (method: string) => {
    switch (method) {
      case 'cash':
        return 'Cash Payment';
      case 'paypal':
        return 'PayPal';
      case 'stripe':
        return 'Credit/Debit Card';
      default:
        return method;
    }
  };

  const getMethodDescription = (method: string) => {
    switch (method) {
      case 'cash':
        return 'Pay in cash at the time of service';
      case 'paypal':
        return 'Pay securely with PayPal';
      case 'stripe':
        return 'Pay with credit or debit card';
      default:
        return '';
    }
  };

  return {
    paymentMethods,
    loading,
    error,
    getMethodTitle,
    getMethodDescription,
  };
};